import App from '@ClientPortal/App.vue'
import axios from 'axios'
import { routes } from '@ClientPortal/routes'
import { ServerTable, ClientTable, Event } from 'vue-tables-2'
import VuejsDialog from "vuejs-dialog"
import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import Auth from "@okta/okta-vue";
import { LoginCallback } from '@okta/okta-vue'
import { OktaAuth } from '@okta/okta-auth-js'
import _ from 'lodash';
import '@okta/okta-signin-widget/dist/css/okta-sign-in.min.css'

const securityProfiles = process.env.SECURITY_PROFILE.split(",")

localStorage.setItem("active_profiles",process.env.SECURITY_PROFILE)

Vue.use(VueRouter)

if(securityProfiles.includes('security-okta')){
    const oktaAuth = new OktaAuth({  
        issuer: process.env.OKTA_ISSUER
    })
    Vue.use(Auth, { oktaAuth })
}

var loaded = false

export function isLoaded() { return loaded; }
export function setLoaded(val) { loaded = val; }

export var axiosRequests = axios.create({
    baseURL: process.env.APP_URL + "/cp",
    headers: {
        authorization: localStorage.getItem("token")
    }
})

// Parse decimals given they appear inside
// html elements and have currency symbols in them
// as well as 'k','m','b' multipliers.
// Additionally, account for holder and gain keywords
// as well as nan.
// There are also cases where the data has no decimal
// values in it, and that should be treated as a special
// case.
export function getDecimals(str) {
  var output = "";
  var multiplier = 1;
  // Avoid issues with case and decimal being inside
  // html elements.
  if (typeof(str) != "string") {
    str = String(str)
  }
  str = str.toLowerCase();
  var end = str.indexOf("</"); // First matching tag ending.
  if(end != -1) {
    str = str.substr(0, end);
  }
  var isNonNumeric = true
  for (let i = 0; i < str.length; i++) {
    var c = str[i];
    if (c >= '0' && c <= '9') {
      isNonNumeric = false
    }
  }
  if(str.indexOf("nan") != -1) {
    return 0;
  }
  if(str.indexOf("holder") != -1) {
    return 0;
  }
  if(str.indexOf("gain") != -1) {
    return 1;
  }
  if(isNonNumeric) {
    // There is no decimals here, and it's not one of 
    // the aforementioned strings, probably just random junk string.
    return 2;
  }
  console.log(str);
  for (let i = 0; i < str.length; i++) {
    var c = str[i];
    // Accept decimal as -/+[0-9]+.[0-9]+
    // Ignore currency symbol (any) so globals should work.
    if (c == '.' || c == '-' || c == '+' || (c >= '0' && c <= '9')) {
      output += c; // Ok part of decimal
    }
    // Multiply to get correct value.
    if (c == 'b' || c == 'B') {
      multiplier *= 1000000000;
    }
    if (c == 'm' || c == 'M') {
      multiplier *= 1000000;
    }
    if (c == 'k' || c == 'K') {
      multiplier *= 1000;
    }
  }
  var number = parseFloat(output) * multiplier;
  if(isNaN(number)) {
    return 0;
  }
  return number;
}

function verifyToken(token, page) {
    return axiosRequests.get("/", {
        headers: {
            authorization: token,
            page: page
        }
    })
}

var init = 1

//TODO: If more of these are need -- we might need a helpers directory
export function parseUserFromToken(token){
    let payload = token.split(".")[1]
    let parsedPayload = JSON.parse(atob(payload))
    let roles = []
    let privileges = []
    
    parsedPayload.authorities.forEach(auth =>{
        if(auth.includes("ROLE_")){
            //console.log("RGD: ROLE_ " + auth)
            roles.push(auth)
        }else{
            //console.log("RGD: " + auth)
            privileges.push(auth)
        }
    })
    
    //console.log("RGD: userId: " + parsedPayload.sub)
    // DEBUG
    let user = {
        userId: parsedPayload.sub,
        username: parsedPayload.username,
        roles,
        privileges,
        clientName: parsedPayload.clientName,
        clientId: parsedPayload.clientId,
        isEnhanced: "prod",
    }
    return user
}

export function parseUserFromOktaToken(payload){
    // RGD TODO This is how we would login from Okta,
    //          we can setup a check for clientId's here calling
    //          into a database table, and a check later on to see if it's
    //          authorized.
    //console.log("RGD: parseUserFromOktaToken")
    var clientNames = []
    var isEnhanced = "prod"
    if(payload.parsedToken.claims.client_NAMES) {
      for (let i = 0; i < payload.parsedToken.claims.client_NAMES.length; i++) {
        if(payload.parsedToken.claims.client_NAMES[i] == "europe") {
          isEnhanced = "europe"
        } else if(payload.parsedToken.claims.client_NAMES[i] == "canada") {
          isEnhanced = "canada"
        } else {
          clientNames.push(payload.parsedToken.claims.client_NAMES[i])
        }
      }
    }
    // DEBUG:
    //clientNames.push("Sun Valley Trust")
    //payload.parsedToken.claims.client_IDS.push(269)

    // Can also use clientName and direct comparison to it.
    let user = {
        username: payload.claims.name,
        //roles: payload.parsedToken.claims.roles, // RGD: DEBUG
        //privileges: payload.parsedToken.claims.privileges, // RGD: DEBUG
        clientId: payload.parsedToken.claims.clientId,
        clientName: payload.parsedToken.claims.clientName,
        //client_IDS: payload.parsedToken.claims.client_IDS.split(",").map(Number),
        //client_NAMES: payload.parsedToken.claims.client_NAMES.split(","),
        client_IDS: payload.parsedToken.claims.client_IDS ? payload.parsedToken.claims.client_IDS : [],
        client_NAMES: clientNames,//payload.parsedToken.claims.client_NAMES,
        groups: payload.parsedToken.claims.groups? payload.parsedToken.claims.groups: [],
        isEnhanced: payload.parsedToken.claims.isEnhanced ? payload.parsedToken.claims.isEnhanced : isEnhanced
    }
    /*
    var t = JSON.stringify(payload.parsedToken)
    console.log("RGD: user from Okta: " + t)
    var c = JSON.stringify(payload.parsedToken.claims)
    console.log("RGD: user from Okta: " + c)
    var s = JSON.stringify(user)
    console.log("RGD: user from Okta: " + s)
    
    DEBUG

    var clientNamesStr = JSON.stringify(clientNames)
    console.log(`processed clientNames ${clientNamesStr}`)
    console.log(`isEnhanced ${isEnhanced}`)
    var str = JSON.stringify(payload.parsedToken)
    var claims = JSON.stringify(payload.parsedToken.claims)
    console.log(`login as isEnhanced ${payload.parsedToken.claims.isEnhanced} ${str} claims=${claims}`)
    */
    var userStr = JSON.stringify(user)
    console.log(` NOTE user from Okta: ${userStr}`)
    axiosRequests.defaults.headers.authorization = payload.parsedToken
    localStorage.setItem("token", payload.parsedToken)
    var stateClient = localStorage.getItem("stateClient")
    if(stateClient == 0) {
      localStorage.setItem("stateClient", payload.parsedToken.claims.clientId)
    }
    return user
}

export function waitForToken(){
   // Just a no-op used for debugging.
   // while(axiosRequests.defaults.headers.authorization == null) {
   //   console.log("waitForToken:: null")
   // }
   //console.log("waitForToken:: " + axiosRequests.defaults.headers.authorization)
}

export function fakeParseUserFromOktaToken(payload){
    // THIS IS USED FOR TESTING MULTIPLE CLIENT ACCESS
    // Normally, this will be setup from the above after Okta login.
    let user = {
        username: "admin",
        clientId: 269,
        clientName: "Sun Valley Trust",
        client_IDS: [269, 259],
        client_NAMES: ["Sun Valley Trust", "Union Asset Management"],
        groups: [],
        isEnhanced: "prod"
    }
    return user
}


Vue.use(VuejsDialog, {html:true})
Vue.use(Vuex)
Vue.use(ServerTable, [
    {
        texts: {
            filter: "Search:"
        },
        datepickerOptions: {
            showDropdowns: true
        }
    }
])
Vue.use(ClientTable, [
    {
        texts: {
            filter: "Search:"
        },
        datepickerOptions: {
            showDropdowns: true
        }
    }
])

const router = new VueRouter({
    mode: 'history',
    routes: [
        ...routes,
        {
            path: '/implicit',
            component: LoginCallback
        }
    ],
    // routes,
    scrollBehavior() {
      return {x: 0, y: 0}
    }
})


const vuexLocalStorage = new VuexPersist({
    key: 'vuex', 
    storage: window.localStorage
  })


//TODO: Extract store to its own directory, and state, mutations, and actions to sub directories
const store = new Vuex.Store({
    state: {
        user: null,
        baseURL: process.env.BASE_URL,
        appURL: process.env.APP_URL,
        clientName: "",
        clientId: null,
        systemMessage: "",
        client_IDS: [],
        client_NAMES: []
    },
    getters: {
        isAdmin(state){
            try{
                return state.user.roles.includes("ROLE_ADMIN")
            }catch(err){
                return false
            }
        },
        isLoggedIn(state){
            return !!state.user
        }
    },
    mutations: {
        setClient(state, payload){
            state.clientId = payload.user.clientId
            state.clientName = payload.user.clientName
            state.client_IDS = payload.user.client_IDS
            state.client_NAMES = payload.user.client_NAMES
        },
        changeClient(state, payload){ // RGD This is called from Header.vue in this.$store.commit('changeClient'
            state.clientId = payload.id
            state.clientName = payload.name
            state.user.clientId = payload.id
            state.user.clientName = payload.name
            localStorage.setItem("stateClient", payload.id)
            router.go()
        },
        setUser(state, payload){
            state.user = payload.user
        },
        setToken(state, token){
            axiosRequests.defaults.headers.authorization = "Bearer " + token
            localStorage.token = "Bearer " + token
        },
        setSystemMessage(state, payload){
            state.systemMessage = payload.message
        },
        resetState(state, payload){
            //TODO: Could alternatively wipe out entire local storage
            state.user = null
            state.systemMessage = ""
            localStorage.clear()
            localStorage.setItem("stateClient", 0)
            axiosRequests.defaults.headers.authorization = null
        }
    },
    actions: {
        setClient({commit}, payload){
            commit('setClient', payload)
        },
        async logout({commit, dispatch}){
            // This may race, hold off for now
            //if(securityProfiles.includes('security-okta')){
            //  await oktaAuth.signOut();
            //}
            commit('resetState')
            if(securityProfiles.includes('security-okta')){
                //Method causing endless redirect - I beleive the method before re-directing mainly clears out okta-token-storage from local storage that can be done manually
                // await Vue.prototype.$auth.signOut()
            }
            router.push("/login")
        },
        loginFromToken({commit, dispatch}, payload){
            const user = parseUserFromToken(payload.token)
            localStorage.setItem('token', payload.token)
            axiosRequests.defaults.headers.authorization = payload.token
            commit('setUser', { user })
            commit('setClient', { user })
        },
        loginFromOktaToken({commit, dispatch}, payload){
            const user = parseUserFromOktaToken(payload)
            const token = payload.token
            commit('setToken',  token )
            commit('setUser', { user })
            commit('setClient', { user })
            //console.log("RGD: login stateClient == 0")
            //localStorage.setItem("stateClient", 0)
        },
        setSystemMessage({commit}, payload){
            commit('setSystemMessage', payload)
        },
        loginFromForm({commit}, payload){
            //using axios.post directly since login route is different namespace from API
            //console.log("RGD: token:")
            //console.log(`${process.env.APP_URL}/login`)
            //console.log("RGD: Payload: " + payload)
            axios.post(`${process.env.APP_URL}/login`, {data: payload})
            .then(resp => {
                const token = resp.headers.authorization
                // We need to modify the API axios instance to send the new token with the requests
                const user = parseUserFromToken(token)

                axiosRequests.defaults.headers.authorization = token
                localStorage.setItem("token", token)
                commit('setUser',{ user })
                commit('setClient', { user })
                router.push("/")
            })
            .catch(err=>{
                if(err.response && err.response.status === 403){
                   commit(
                       'setSystemMessage',
                       { message: "Unable to verify credentials, please check credentials and try again" }
                    )
                } else {
                    commit(
                        'setSystemMessage',
                        { message: "Something went wrong, please try again in a few minutes" }
                    )
                }
            })
        }
    },
    plugins: [vuexLocalStorage.plugin]
})


const securityDbAuthGuard = ((to, from, next) => {
    let token = localStorage.getItem('token')
    let page = to['name']
    //Have to catch case when token is deleted/expired, but user tries to continue interaction with the app
    verifyToken(token,page).catch((e)=>{
        console.log(e)
        store.dispatch('logout')
    })
    if(to.path != '/login') {
        if(store.getters.isLoggedIn) {
            //There is a user, parse and resume.
            if (to.matched.some(record => record.meta.requiresAdmin)) {
                // if this route requires Admin, check if Admin
                // if not, redirect to forbidden.
                if (!store.getters.isAdmin) {
                    next({
                    path: '/forbidden',
                    query: { redirect: to.fullPath }
                    })
                } else {
                    //if Admin, proceed
                    if(to.path !== 'login'){
                        //If user exists and route is login, redirect to home
                        next()
                    } else {
                        //otherwise, proceed
                        next('/')
                    }
                }
            } else {
                // Route doesn't require admin, proceed

                if(to.path !== 'login'){
                    //If user exists and route is login, redirect to home
                    next()
                } else {
                    //otherwise, proceed
                    next('/')
                }
            }
        } else {
            //There is no user, redirect to login.
            next('login');
        }
    } else {

        if(store.getters.isLoggedIn){
            // if user present, redirect away from login
            next('/')
        } else {
            // if no user no need to redirect, already on login route
            next();
        }
    }
})


const oktaAuthGuard = async (to, from, next) => {
    var isAuthenticated = await Vue.prototype.$auth.isAuthenticated()
    if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
        store.dispatch('logout')
    }
    else {
        next()
    }
}

//Check Authentication before Navigating away from routes based on auth profile
const checkAuthentication = ((to, from, next) => {
    if(securityProfiles.includes('security-okta')){
        oktaAuthGuard(to, from, next)
    } 
    else if(securityProfiles.includes('security-db')){
        securityDbAuthGuard(to, from, next)
    }
    else{
        next()
    }
})
  
router.beforeEach(checkAuthentication)

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})
